export const TEXTS = {
    es: {
        nav: {
            home: "Inicio",
            services: "Servicios",
            projects: "Proyectos",
            team: "Equipo",
            contact: "Contacto",
        },
        hero: {
            designerTitle: "diseño",
            designerSubtitle:
                "Diseñadores de productos especializado en UI y diseño de sistemas.",
            coderTitle: "<código>",
            coderSubtitle:
                "Desarrolladores Front-end & back-end quienes escriben código limpio, elegante y código eficeinte.",
            startProject: "Empezar un proyecto",
            seeServices: "Mirar servicios",
        },
        sections: {
            services: {
                title: "Servicios",
                subtitle:
                    "Soluciones diseñadas para acelerar tus proyectos de datos, automatización y desarrollo.",
                items: [
                    {
                        key: "development",
                        iconLabel: "Grid",
                        title: "Desarrollo de Software",
                        description:
                            "Python, Java, JavaScript.\nProgramación Orientada a Objetos (POO), programación funcional, patrones de diseño, servicios RESTful, pruebas y control de versiones con Git.",
                    },
                    {
                        key: "frontend",
                        iconLabel: "Code",
                        title: "Desarrollo Frontend",
                        description:
                            "HTML5, CSS3, JavaScript, TypeScript.\nReact, Next.js, diseño responsivo, arquitectura basada en componentes, gestión de estado y optimización del rendimiento de la UI.",
                    },
                    {
                        key: "backend",
                        iconLabel: "Analytics",
                        title: "Desarrollo Backend",
                        description:
                            "Python, Django.\nAPIs REST, diseño de bases de datos (SQL), autenticación y autorización, tareas en segundo plano y arquitectura escalable del lado del servidor.",
                    },
                ],
            },
            projects: {
                title: "Proyectos",
                description: "Portafolio de proyectos destacados.",
            },
        },
        team: {
            heading: "Conoce al equipo",
            subtitle:
                "Las mentes creativas y técnicas que impulsan UGCSAC. Nos apasiona construir soluciones digitales excepcionales.",
            members: [
                {
                    name: "Luis Bazalar",
                    role: "Full-Stack Developer",
                },
                {
                    name: "Renzo Alvarado",
                    role: "Cloud & DevOps Engineer",
                },
                {
                    name: "Sebastián Palomares",
                    role: "UX / UI Designer",
                },
            ],
        },
        contact: {
            title: "¡Envíanos un mensaje!",
            subtitle:
                "Nos encantará saber de ti. Completa el formulario y te responderemos lo antes posible.",
            form: {
                nameLabel: "Nombre",
                namePlaceholder: "e.g., Juan Pérez",
                emailLabel: "Email",
                emailPlaceholder: "e.g., juan.perez@empresa.com",
                companyLabel: "Empresa (opcional)",
                companyPlaceholder: "e.g., Mi Empresa S.A.C.",
                messageLabel: "Tu mensaje",
                messagePlaceholder:
                    "Cuéntanos sobre tu proyecto, objetivos o cualquier consulta que tengas...",
                sendButton: "Enviar",
                preferEmail: "¿Prefieres escribir directo?",
                email: "renzo@ugcsac.com",
                responseTime: "Normalmente respondemos en 24 horas hábiles.",
            },
        },
        projects: {
            title: "Proyectos",
            description: "Portafolio de proyectos destacados.",
            items: [
                {
                    id: "sigma-insight",
                    tag: "Riesgos & Analítica",
                    title: "Sigma Insight",
                    problem:
                        "El equipo de riesgos consolidaba información desde múltiples fuentes, con procesos manuales y poca trazabilidad, lo que retrasaba la toma de decisiones.",
                    solution:
                        "Diseñamos una plataforma de automatización y analítica que estandariza flujos, valida consistencia y genera tableros listos para comité.",
                    metrics: ["-70% tiempo de preparación", "+Trazabilidad end-to-end"],
                    ctaPrimary: "Ver sitio",
                    ctaSecondary: "Leer caso",
                    websiteUrl: "#",
                    caseUrl: "#",
                },
                {
                    id: "liftco-management",
                    tag: "Operaciones",
                    title: "LIFTCO - Management App",
                    problem:
                        "La gestión de órdenes, técnicos, inventario y reportes se hacía en herramientas separadas, generando duplicidad y demoras operativas.",
                    solution:
                        "Construimos una app web con módulos integrados, control de estados, reportes y APIs para centralizar la operación y mejorar productividad.",
                    metrics: ["-50% tareas administrativas", "+Visibilidad por módulo"],
                    ctaPrimary: "Ver sitio",
                    ctaSecondary: "Leer caso",
                    websiteUrl: "#",
                    caseUrl: "#",
                },
            ],
        },
    },

    en: {
        nav: {
            home: "Home",
            services: "Services",
            projects: "Projects",
            team: "Team",
            contact: "Contact",
        },
        hero: {
            designerTitle: "designer",
            designerSubtitle:
                "Product designer specializing in UI and design systems.",
            coderTitle: "<coder>",
            coderSubtitle:
                "Front-end & back-end developer who writes clean, elegant, and efficient code.",
            startProject: "Start a project",
            seeServices: "See services",
        },
        sections: {
            services: {
                title: "Services",
                subtitle:
                    "Solutions designed to accelerate your data, automation and development projects.",
                items: [
                    {
                        key: "development",
                        iconLabel: "Grid",
                        title: "Software Development",
                        description:
                            "Python, Java, JavaScript.\nObject-Oriented Programming (OOP), functional programming, design patterns, RESTful services, testing, and version control with Git.",
                    },
                    {
                        key: "frontend",
                        iconLabel: "Code",
                        title: "Frontend Development",
                        description:
                            "HTML5, CSS3, JavaScript, TypeScript.\nReact, Next.js, responsive design, component-based architecture, state management, and UI performance optimization",
                    },
                    {
                        key: "backend",
                        iconLabel: "Analytics",
                        title: "Backend Development",
                        description:
                            "Python, Django.\nREST APIs, database design (SQL), authentication & authorization, background tasks, and scalable server-side architecture.",
                    },
                ],
            },
            projects: {
                title: "Projects",
                description: "Portfolio of featured projects.",
            },
        },
        team: {
            heading: "Meet the Team",
            subtitle:
                "The brilliant minds and skilled developers driving our success. We're passionate about crafting exceptional digital experiences.",
            members: [
                {
                    name: "Luis Bazalar",
                    role: "Full-Stack Developer",
                },
                {
                    name: "Renzo Alvarado",
                    role: "Cloud & DevOps Engineer",
                },
                {
                    name: "Sebastián Palomares",
                    role: "UX / UI Designer",
                },
            ],
        },
        contact: {
            title: "Send us a message!",
            subtitle:
                "We’d love to hear from you. Fill out the form below and we’ll get back to you as soon as possible.",
            form: {
                nameLabel: "Name",
                namePlaceholder: "e.g., Jane Doe",
                emailLabel: "Email",
                emailPlaceholder: "e.g., jane.doe@example.com",
                companyLabel: "Company (optional)",
                companyPlaceholder: "e.g., Example Inc.",
                messageLabel: "Your Message",
                messagePlaceholder:
                    "Tell us about your project, goals, or any questions you have...",
                sendButton: "Send",
                preferEmail: "Prefer to email directly?",
                email: "renzo@ugcsac.com",
                responseTime: "We typically respond within 24 business hours.",
            },
        },
        projects: {
            title: "Projects",
            description: "Portfolio of featured projects.",
            items: [
                {
                    id: "sigma-insight",
                    tag: "Risk & Analytics",
                    title: "Sigma Insight",
                    problem:
                        "The risk team had to consolidate data from multiple sources with manual steps and limited traceability, slowing decision-making.",
                    solution:
                        "We built an automation and analytics platform that standardizes pipelines, validates consistency, and delivers committee-ready dashboards.",
                    metrics: ["-70% prep time", "+End-to-end traceability"],
                    ctaPrimary: "Visit Website",
                    ctaSecondary: "Read Case Study",
                    websiteUrl: "#",
                    caseUrl: "#",
                },
                {
                    id: "liftco-management",
                    tag: "Operations",
                    title: "LIFTCO - Management App",
                    problem:
                        "Jobs, technicians, inventory, and reporting were managed across separate tools, creating duplication and operational delays.",
                    solution:
                        "We delivered a web app with integrated modules, workflow states, reporting, and APIs to centralize operations and boost productivity.",
                    metrics: ["-50% admin tasks", "+Module-level visibility"],
                    ctaPrimary: "Visit Website",
                    ctaSecondary: "Read Case Study",
                    websiteUrl: "#",
                    caseUrl: "#",
                },
            ],
        },
    },
};
